module.exports = __webpack_public_path__ + "static/media/icon_weicaizhon.cc5ca0a7.png";